import React from 'react'

const getMachineLabel = machine => {
  if (!machine) return ''

  const name = machine.MachineName || machine.Name || 'Automat'
  const serialNo = machine.SerialNo || machine.MachineSerialNo || ''

  if (!serialNo || String(name).includes(String(serialNo))) return name

  return `${name} ${serialNo}`
}

const ImportWarningModal = ({
  show,
  machines = [],
  isImporting = false,
  onClose,
  onConfirm,
}) => {
  if (!show) return null

  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      role="dialog"
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.45)' }}
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Potwierdzenie importu</h5>
            <button
              type="button"
              className="close"
              aria-label="Zamknij"
              disabled={isImporting}
              onClick={onClose}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div className="modal-body">
            <p className="mb-3 pe-none">
              Czy na pewno chcesz importować produkty na podanych automatach?
            </p>

            <ul className="mb-0 pl-4">
              {machines.map(machine => (
                <li key={machine.MachineId} className="mb-1">
                  {getMachineLabel(machine)}
                </li>
              ))}
            </ul>

            <div className="alert alert-warning mt-3 mb-0 pe-none" role="alert">
              <strong>Uwaga:</strong> Import usunie obecne wybory z automatów
              {' '}i zastąpi je wyborami z pliku. Numery wyborów zostaną nadpisane na wszystkich wybranych automatach
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              disabled={isImporting}
              onClick={onClose}
            >
              Anuluj
            </button>
            <button
              type="button"
              className="btn btn-primary"
              disabled={isImporting || machines.length === 0}
              onClick={onConfirm}
            >
              {isImporting ? (
                <>
                  <i className="fas fa-spinner fa-spin mr-2" />
                  Importowanie...
                </>
              ) : (
                <>
                  Importuj
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ImportWarningModal